import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=41f676aa&scoped=true&"
import script from "./ListProduct.vue?vue&type=script&lang=ts&"
export * from "./ListProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=41f676aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f676aa",
  null
  
)

export default component.exports